import { jsx, jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import PropTypes from "prop-types";
import { LegendIconCircle, LegendIconLine, LegendItemWrapper, LegendIcon, LegendLabel, LegendValue } from "./legend-item.styles.es.js";
const propTypes = {
  icon: PropTypes.oneOfType([
    PropTypes.shape({
      color: PropTypes.string,
      size: PropTypes.oneOf(["small", "medium"]),
      type: PropTypes.oneOf(["circle", "line"])
    }),
    PropTypes.node
  ]),
  label: PropTypes.string,
  value: PropTypes.string
};
const defaultProps = {
  icon: void 0,
  label: void 0,
  value: void 0
};
const LegendItem = ({ icon, label, value }) => {
  const iconComponent = useMemo(() => {
    if (!!icon && typeof icon === "object" && "type" in icon && ("color" in icon || "size" in icon)) {
      const IconComponent = {
        circle: LegendIconCircle,
        line: LegendIconLine
      }[icon.type];
      return /* @__PURE__ */ jsx(IconComponent, { color: icon.color, size: icon.size });
    }
    return icon;
  }, [icon]);
  return /* @__PURE__ */ jsxs(LegendItemWrapper, { children: [
    iconComponent && /* @__PURE__ */ jsx(LegendIcon, { children: iconComponent }),
    /* @__PURE__ */ jsx(LegendLabel, { children: label }),
    value && /* @__PURE__ */ jsx(LegendValue, { children: value })
  ] });
};
LegendItem.propTypes = propTypes;
LegendItem.defaultProps = defaultProps;
export {
  LegendItem
};
